export default __webpack_public_path__ + "30a6da9ff38e16808cad1d0af71e72ea.ttf";